module.exports = __webpack_public_path__ + "img/881.30f006f5.gif";